// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alphabetNavigationStyles } from "@awc/Overrides/Widgets/Brand/AlphabetNavigation";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { getSystemColor } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

alphabetNavigationStyles.navigationItem = {
    css: css`
        min-width: 35px;
        height: 24px;
        display: flex;
        justify-content: center;
        margin: 0;
    `,
};

alphabetNavigationStyles.navigationTextEmpty = {
    transform: "capitalize",
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    size: fontConfig.fontSize.singleLineRegular,
    weight: fontConfig.weight.regular,
    color: "text.link",
    css: css`
        display: flex;
        align-items: center;
        opacity: 0.33;
        cursor: not-allowed;
    `,
};

alphabetNavigationStyles.navigationLink = {
    color: "text.link",
    typographyProps: {
        transform: "capitalize",
        lineHeight: fontConfig.lineHeight.singleLineRegular,
        size: fontConfig.fontSize.singleLineRegular,
    },
    css: css`
        ${TypographyStyle} {
            padding: 8px 4px;
            ${({ lastLetterClicked }: any) => {
                return lastLetterClicked
                    ? css`
                          font-weight: ${fontConfig.weight.bold};
                          text-decoration: underline;
                          color: ${getSystemColor("common.ui9")};
                      `
                    : css`
                          color: ${getSystemColor("text.link")};
                      `;
            }}
        }
    `,
};
